import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { fetchConToken } from '../../../api/fetch';
import classNames from 'classnames';
import { useContextInfo } from '../../../context/ContextInfo';

const ModalScreen = ({ id }) => {
    const [anuncio, setAnuncio] = useState(null);
    const { setResp } = useContextInfo();

    const [show, setShow] = useState(false);
    useEffect(() => {
        getAnuncios();
    }, [id]);
    useEffect(() => {
        if (anuncio) {
            setShow(true);
        }
    }, [anuncio]);
    const getAnuncios = async () => {
        const resp = await fetchConToken(`proxy/anuncios`, { id, tipo: 'cx' }, 'POST');
        if (resp.ok) {
            const { data } = resp;
            if (data.hasOwnProperty('foto')) setAnuncio(resp.data);
        }
    };
    const delAnuncio = async () => {
        const r = await fetchConToken(`proxy/avisocx/${anuncio.id}`, {}, 'DELETE');
        setShow(false);
        if (r.ok) setResp(r);
    };
    const handleClose = () => setShow(false);
    return (
        <Modal size="sm" centered show={show} onHide={handleClose}>
            <div className={classNames('modal-filled', 'bg-info')}>
                <Modal.Body className="p-4">
                    <div className="text-center">
                        <i className="dripicons-warning h1"></i>
                        <h4 className="mt-2">Anuncio!</h4>
                        <p className="mt-3">{anuncio?.descripcion}</p>
                        <button type="button" className="btn btn-light my-2" onClick={delAnuncio}>
                            No mostarar de Nuevo
                        </button>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default ModalScreen;
